import i18next from "i18next";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";

// Own Pages.
import ErrorPage from "./Pages/404";
import HomePage from "./Pages/HomePage";
import ContactUs from "./Pages/ContactUs";

// Own Components.
import ScrollToTop from "./Components/ScrollToTop";

// Styles Global
import "./global.css";

// Store
import store from "./Redux/Store";

import global_en from "./Translation/En/global.json";
import global_es from "./Translation/Es/global.json";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

export const baseNameUrl = "/";

export const keySite = process.env.REACT_APP_SITE_KEY || "";

// eslint-disable-next-line
const ParentPage = ({ page }: any) => (
  <>
    <ScrollToTop />
    {page}
  </>
);

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <ParentPage page={<HomePage />} />,
      errorElement: <ErrorPage />,
    },
    {
      path: "/contact-us",
      element: <ParentPage page={<ContactUs />} />,
      errorElement: <ErrorPage />,
    },
  ],
  { basename: baseNameUrl }
);

i18next.init({
  interpolation: { escapeValue: false },
  lng: "en",
  resources: {
    es: {
      global: global_es,
    },
    en: {
      global: global_en,
    },
  },
});

root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18next}>
      <GoogleReCaptchaProvider reCaptchaKey={keySite}>
        <RouterProvider router={router} fallbackElement={<p>Loading...</p>} />
      </GoogleReCaptchaProvider>
    </I18nextProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
